export default __webpack_public_path__ + "static/media/recipe1.07a97e41.png";